<template>
    <div>
      <el-dialog :visible.sync="centerDialogVisible" top="20vh" width="300px" center :close-on-click-modal=false :close-on-press-escape=false>
        <div class="content">
          <div class="teacher-code">
            <img src="@/assets/tbx_code_2.jpg" alt="">
          </div>
          <p>扫码下载同步学，用手机号登录，<br>即可使用同步配套电子教材</p>
        </div>
      </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'TBXCoddDialog',
  data () {
    return {
      centerDialogVisible: false,
      bindBtnDisabled: false,
      activationInput: '',
      tipText: ''
    }
  },
  watch: {
    'activationInput' () {
      this.tipText = ''
    },
    'centerDialogVisible' (show) {
      if (show === false) {
        this.activationInput = ''
      }
    }
  },
  methods: {
    showDialog (vipStatus) {
      if (vipStatus === 3) {
        this.tipText = '激活码已过期，请重新激活'
      }
      this.centerDialogVisible = true
    },
    activateVersion () {
      let code = this.activationInput
      if (!code) {
        this.tipText = '验证码不能为空'
      } else if (code.length < 8) {
        this.tipText = '请确认激活码的位数'
      } else {
        api.post('ActivateVersionRequest', {
          code: code,
          type: 2
        }, res => {
          if (res.body.activeStatus === 1) {
            this.$message({
              message: '成功激活' + res.body.versionName + '电子教材',
              type: 'success'
            })
            this.afterActive()
          } else {
            this.tipText = '激活码无效'
          }
        }, res => {
          if (res.result.retCode === 3000301) {
            this.tipText = '激活码无效'
          }
        })
      }
    },
    afterActive () {
      this.centerDialogVisible = false
      this.$emit('afterActive')
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  width: 250px;
  padding-bottom: 15px;
}
.teacher-code{
  padding-top: 10px;
  text-align: center;
  img{
      height: 160px;
      width: 160px;
  }
}
p {
  text-align: center;
}
</style>
